export default function ThemesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('themes');
}

ThemesConfiguration.$inject = ['$translatePartialLoaderProvider'];
